<div class="top-products">
  <div class="top-products-totals">
    <div class="top-products-total">
      <div class="top-products-total-label">{{ 'PRODUCTS' | translate }}</div>
      <div class="top-products-total-value">{{ totals.products | number }}</div>
    </div>
    <div class="top-products-total">
      <div class="top-products-total-label">{{ 'TOTAL_QUANTITY' | translate }}</div>
      <div class="top-products-total-value">{{ totals.quantity | number: '1.0-2' }}</div>
    </div>
    <div class="top-products-total">
      <div class="top-products-total-label">{{ 'NUMBER_OF_ORDERS' | translate }}</div>
      <div class="top-products-total-value">{{ totals.orders | number }}</div>
    </div>
    <div class="top-products-total">
      <div class="top-products-total-label">{{ 'CUSTOMERS' | translate }}</div>
      <div class="top-products-total-value">{{ totals.customers | number }}</div>
    </div>
  </div>

  <div class="top-products-header" aria-hidden="true">
    <div>#</div>
    <div>{{ 'PRODUCT' | translate }}</div>
    <div class="text-end">{{ 'QUANTITY' | translate }}</div>
    <div class="text-end">{{ 'ORDER_COUNT' | translate }}</div>
    <div></div>
    <div></div>
  </div>

  @for (item of _productsSorted; track item.productId) {
    <div class="top-product">
      <div
        class="top-product-body"
        [class.top-product-expanded]="
          (item.number === expandedNumber || item.number === loadingNumber) && item.number !== closingNumber
        "
      >
        <div
          class="top-product-row"
          role="button"
          tabindex="0"
          [class.top-product-loading]="item.number === loadingNumber"
          [attr.aria-busy]="item.number === loadingNumber"
          [attr.aria-expanded]="item.number === expandedNumber"
          [attr.aria-label]="(item.number === expandedNumber ? 'HIDE_DETAILS' : 'SHOW_DETAILS') | translate"
          (click)="toggle(item)"
          (keydown.enter)="toggle(item)"
          (keydown.space)="$event.preventDefault(); toggle(item)"
        >
          <div class="top-product-rank">
            <span class="top-product-rank-badge" [class.text-bg-primary]="item.number <= 3">{{ item.number }}</span>
          </div>

          <div class="top-product-info">
            <div class="top-product-image">
              @if (getImage(item); as image) {
                <img [src]="image.s3Uri | gungImageUrl: 'type:list' : 'etag:' + image.s3ETag" alt="" loading="lazy" />
              } @else {
                <i class="far fa-image" aria-hidden="true"></i>
              }
            </div>
            <div class="top-product-name">
              <div class="fw-semibold">{{ productsInfo[item.productId]?.name || item.productName }}</div>
              <div class="small text-body-secondary">{{ item.productId }}</div>
            </div>
          </div>

          <div class="top-product-quantity">
            <div class="top-product-bar">
              <span [style.width.%]="getBarWidth(item)"></span>
            </div>
            <span class="top-product-share small text-body-secondary">{{
              getShareOfQuantity(item) | percent: '1.1-1'
            }}</span>
            <span class="top-product-qty fw-bold">{{ item.qty | number: '1.0-2' }}</span>
          </div>

          <div class="top-product-orders text-end">
            <span class="top-product-mobile-label small text-body-secondary">{{ 'ORDER_COUNT' | translate }}</span>
            {{ item.orderCount | number }}
          </div>

          <div class="top-product-actions" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
            <lib-action-btn [item]="item" [config]="buttonConfigService"></lib-action-btn>
          </div>

          <div class="top-product-chevron">
            <i class="fas fa-chevron-down" aria-hidden="true"></i>
          </div>
        </div>

        @if (item.number === expandedNumber || item.number === loadingNumber) {
          <div
            class="top-product-details"
            [class.top-product-details-loading]="item.number === loadingNumber"
            [class.top-product-details-closing]="item.number === closingNumber"
          >
            <div class="table-responsive" (scroll)="onDetailsScroll($event, item)">
              <table class="table table-sm mb-0">
                <thead>
                  <tr>
                    <th>{{ 'CUSTOMER' | translate }}</th>
                    <th>{{ 'PRODUCT_ID' | translate }}</th>
                    <th>{{ 'SIZE' | translate }}</th>
                    <th>{{ 'ORDER_ID' | translate }}</th>
                    <th class="text-end">{{ 'ROW' | translate }}</th>
                    <th class="text-end">{{ 'QUANTITY' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  @if (item.number === loadingNumber) {
                    @for (row of skeletonRows | slice: 0 : item.subItems?.length; track $index) {
                      <tr class="top-product-skeleton placeholder-glow" aria-hidden="true">
                        <td><span class="placeholder w-75"></span></td>
                        <td><span class="placeholder w-50"></span></td>
                        <td><span class="placeholder w-25"></span></td>
                        <td><span class="placeholder w-50"></span></td>
                        <td class="text-end"><span class="placeholder w-25"></span></td>
                        <td class="text-end"><span class="placeholder w-50"></span></td>
                      </tr>
                    }
                  } @else {
                    @for (subItem of item.subItems | slice: 0 : detailRowLimit; track $index; let rowIndex = $index) {
                      <tr>
                        <td>
                          <div class="top-product-customer">
                            <ng-container
                              *ngTemplateOutlet="
                                copyableLink;
                                context: {
                                  value: subItem.customerId,
                                  link: ['/customers', subItem.customerId],
                                  key: 'customer-' + rowIndex
                                }
                              "
                            ></ng-container>
                            <span class="text-body-secondary">{{ subItem.customerName }}</span>
                          </div>
                        </td>
                        <td>
                          <ng-container
                            *ngTemplateOutlet="
                              copyableLink;
                              context: {
                                value: subItem.productId,
                                link: ['/product', subItem.productId],
                                key: 'product-' + rowIndex
                              }
                            "
                          ></ng-container>
                        </td>
                        <td>{{ subItem.productSecondaryDimensionName }}</td>
                        <td>
                          <ng-container
                            *ngTemplateOutlet="
                              copyableLink;
                              context: {
                                value: subItem.orderId,
                                link: ['/orders', subItem.orderId],
                                key: 'order-' + rowIndex
                              }
                            "
                          ></ng-container>
                        </td>
                        <td class="text-end">{{ subItem.orderRowNumber }}</td>
                        <td class="text-end">{{ subItem.orderRowTotalQuantity | number: '1.0-2' }}</td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>

<ng-template #copyableLink let-value="value" let-link="link" let-key="key">
  @if (value) {
    <span class="top-product-copyable">
      <a [routerLink]="link">{{ value }}</a>
      <button
        type="button"
        class="top-product-copy"
        [class.top-product-copied]="copiedKey === key"
        [title]="'COPY' | translate"
        [attr.aria-label]="('COPY' | translate) + ' ' + value"
        (click)="copyToClipboard(value, key)"
      >
        <i class="far" [class.fa-copy]="copiedKey !== key" [class.fa-check]="copiedKey === key" aria-hidden="true"></i>
      </button>
    </span>
  }
</ng-template>
